import { useCallback, useMemo } from 'react';
import { useStores } from 'Hooks/useStore';
import { Status } from 'app-types';

/**
 * The properties belonging to one tenant, for forms that ask for a property
 * once a tenant is known. Sourced from the same directory groups endpoint the
 * AssignUsers property picker uses, narrowed to the given tenant.
 */
export const useTenantProperties = () => {
	const { assignUsersStore } = useStores();

	const fetchProperties = useCallback(
		(tenantId?: string) =>
			assignUsersStore
				.fetchPropertiesByTenant(Number(tenantId))
				.catch(() => undefined),
		[assignUsersStore]
	);

	const propertyOptions = useMemo(
		() =>
			assignUsersStore.tenantProperties.map((property) => ({
				value: String(property.id),
				label: property.name
			})),
		[assignUsersStore.tenantProperties]
	);

	const isLoadingProperties =
		assignUsersStore.status.fetchPropertiesByTenant === Status.Pending;

	return { propertyOptions, isLoadingProperties, fetchProperties };
};

export default useTenantProperties;
